import React, { useContext, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Header from "../components/Layout/Header";
import ConfigurationManager from "../components/Settings/ConfigurationManager";
import RepositorySettings from "../components/Settings/RepositorySettings";
import DevOpsSettings from "../components/Settings/DevOpsSettings";
import AISettings from "../components/Settings/AISettings";
import FeedbackChannelSettings from "../components/Settings/FeedbackChannelSettings";
import WorkflowSettings from "../components/Settings/WorkflowSettings";
import { AuthContext } from "../context/AuthContext";

const SettingsPage = () => {
  const { user } = useContext(AuthContext);
  const [selectedConfiguration, setSelectedConfiguration] = useState(null);

  if (user?.role !== "Super User" && user?.role !== "Power User") {
    return (
      <Box>
        <Header />
        <Container maxWidth="lg" sx={{ mt: 4 }}>
          <Alert severity="error">
            You do not have permission to access this page.
          </Alert>
        </Container>
      </Box>
    );
  }

  return (
    <Box>
      <Header />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Settings
        </Typography>

        <ConfigurationManager
          onConfigurationChange={setSelectedConfiguration}
          selectedConfiguration={selectedConfiguration}
        />

        {selectedConfiguration && (
          <>
            <RepositorySettings
              key={`repo-${selectedConfiguration}`}
              configurationId={selectedConfiguration}
            />
            <DevOpsSettings
              key={`devops-${selectedConfiguration}`}
              configurationId={selectedConfiguration}
            />
            <AISettings
              key={`ai-${selectedConfiguration}`}
              configurationId={selectedConfiguration}
            />
            <WorkflowSettings
              key={`workflow-${selectedConfiguration}`}
              configurationId={selectedConfiguration}
            />
            <FeedbackChannelSettings
              key={`feedback-${selectedConfiguration}`}
              configurationId={selectedConfiguration}
            />
          </>
        )}

        {!selectedConfiguration && (
          <Alert severity="info">
            Please create and select a configuration to manage repository,
            DevOps, and AI settings.
          </Alert>
        )}
      </Container>
    </Box>
  );
};

export default SettingsPage;
